module.exports = __webpack_public_path__ + "3ba2903dcd724b0e26bdf3d1286f7f48.svg";